import React from 'react';
import { useTranslation } from 'react-i18next';
import '../scss/unsaved-changes-modal.scss';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
  onSaveAndLeave?: () => void;
  isSaving?: boolean;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onStay,
  onLeave,
  onSaveAndLeave,
  isSaving = false,
}) => {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div className="unsaved-changes-overlay" onClick={onStay}>
      <div className="unsaved-changes-modal" onClick={(e) => e.stopPropagation()}>
        <button className="unsaved-changes-close" onClick={onStay}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="#717680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="unsaved-changes-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
  <g clip-path="url(#clip0_12266_66614)">
    <path d="M33.16 7H33.278C34.1018 7 34.8919 7.3236 35.4744 7.8996C36.0569 8.47561 36.3842 9.25683 36.3842 10.0714C36.3842 10.886 36.0569 11.6673 35.4744 12.2433C34.8919 12.8193 34.1018 13.1429 33.278 13.1429C29.2555 13.1429 26.2394 13.1429 23.8446 13.3333C21.4435 13.5237 20.024 13.8831 19.0673 14.3868C16.9423 15.5286 15.2358 17.3042 14.1906 19.4608C13.6595 20.5481 13.3209 21.9364 13.1407 24.2154C12.9792 26.2364 12.9606 28.7488 12.9544 32.1396L15.1069 30.0142C15.6894 29.4379 16.4795 29.114 17.3034 29.1137C18.1274 29.1134 18.9178 29.4368 19.5006 30.0127C20.0834 30.5886 20.411 31.3699 20.4113 32.1846C20.4116 32.9994 20.0846 33.7809 19.5022 34.3572L12.0474 41.7286C11.7497 42.0237 11.3944 42.2557 11.0031 42.4106C10.6118 42.5656 10.1927 42.6401 9.77137 42.6298C9.35002 42.6194 8.93521 42.5244 8.55218 42.3505C8.16916 42.1765 7.82594 41.9273 7.54342 41.6181L0.803042 34.2466C0.529336 33.9476 0.317885 33.5981 0.180761 33.2182C0.0436378 32.8383 -0.0164726 32.4355 0.00386204 32.0326C0.0241966 31.6297 0.124578 31.2348 0.299275 30.8703C0.473972 30.5058 0.719563 30.1789 1.02203 29.9082C1.32449 29.6376 1.6779 29.4285 2.06208 29.2929C2.44627 29.1573 2.8537 29.0979 3.26111 29.118C3.66852 29.1381 4.06794 29.2374 4.43656 29.4101C4.80518 29.5829 5.13578 29.8257 5.40948 30.1248L6.74513 31.5868C6.74824 28.4601 6.7762 25.8862 6.94703 23.7393C7.15515 21.1009 7.5869 18.8496 8.60262 16.7794C10.2198 13.456 12.857 10.7225 16.1382 8.96879C18.2193 7.86614 20.6607 7.42386 23.3507 7.21193C26.022 7 29.2866 7 33.16 7ZM46.1344 14.3714C46.5552 14.3825 46.9694 14.4781 47.3517 14.6523C47.734 14.8266 48.0765 15.0758 48.3584 15.385L55.1019 22.7564C55.3971 23.0514 55.6287 23.4025 55.7828 23.7884C55.937 24.1744 56.0105 24.5872 55.9988 25.002C55.9871 25.4168 55.8906 25.825 55.715 26.2019C55.5394 26.5788 55.2884 26.9166 54.9771 27.1949C54.6658 27.4732 54.3007 27.6862 53.9038 27.8212C53.507 27.9561 53.0866 28.0101 52.6681 27.98C52.2495 27.9498 51.8415 27.8361 51.4686 27.6457C51.0957 27.4553 50.7657 27.1921 50.4986 26.8721L49.1629 25.4132C49.1567 28.5399 49.1287 31.1138 48.9579 33.2607C48.7498 35.8991 48.318 38.1504 47.3023 40.2206C45.6852 43.544 43.0479 46.2775 39.7668 48.0312C37.6856 49.1308 35.2442 49.5761 32.5543 49.7881C29.883 50 26.6215 50 22.7481 50H22.6238C21.8 50 21.01 49.6764 20.4275 49.1004C19.8449 48.5244 19.5177 47.7432 19.5177 46.9286C19.5177 46.114 19.8449 45.3327 20.4275 44.7567C21.01 44.1807 21.8 43.8571 22.6238 43.8571C26.6494 43.8571 29.6655 43.8571 32.0604 43.6667C34.4614 43.4763 35.881 43.1169 36.8377 42.6132C38.9626 41.4714 40.6692 39.6958 41.7143 37.5392C42.2455 36.4519 42.5841 35.0636 42.7642 32.7846C42.9257 30.7636 42.9475 28.2512 42.9506 24.8604L40.798 26.9858C40.2122 27.5453 39.4276 27.8549 38.6131 27.8479C37.7987 27.8409 37.0196 27.5178 36.4437 26.9484C35.8678 26.3789 35.5412 25.6086 35.5341 24.8032C35.527 23.9979 35.8401 23.2221 36.4059 22.6428L43.8607 15.2714C44.1582 14.9768 44.5132 14.7452 44.9041 14.5905C45.2949 14.4358 45.7135 14.3612 46.1344 14.3714Z" fill="#8C7FC6"/>
  </g>
  <defs>
    <clipPath id="clip0_12266_66614">
      <rect width="56" height="56" fill="white"/>
    </clipPath>
  </defs>
</svg>
        </div>

        <h3 className="unsaved-changes-title">
          {t('UNSAVED_CHANGES_TITLE')}
        </h3>

        <p className="unsaved-changes-desc">
          {t('UNSAVED_CHANGES_DESC')}
        </p>

        <div className="unsaved-changes-footer">
          <button className="unsaved-btn unsaved-btn--outline" onClick={onLeave}>
            {t('STAY_ON_PAGE')}
          </button>
          <button className="unsaved-btn unsaved-btn--primary" onClick={onSaveAndLeave ?? onLeave} disabled={isSaving}>
            {isSaving && <span className="unsaved-btn-spinner" />}
            {t('SAVE_AS_DRAFT_AND_SWITCH')}
          </button>
        </div>
      </div>
    </div>
  );
};
